<template>
  <filter-parent v-if="showFilter" :title="texts.accreditations">
    <multiselect
      v-if="!isLoadingCompetenceAreas"
      v-model="accreditations"
      :options="accreditationOptions"
      :placeholder="texts.startTyping"
    />
    <multiselect-filter-loader v-else />
  </filter-parent>
</template>

<script>
import FilterParent from '../common/FilterParent.vue';
import Multiselect from 'Components/MultiSelect.vue';
import MultiselectFilterLoader from './MultiselectFilterLoader.vue';
import { mapState } from 'vuex';

export default {
  name: 'AccreditationFilter',

  components: {
    FilterParent,
    Multiselect,
    MultiselectFilterLoader,
  },

  data() {
    return {
      texts: theme_vars.counselorGridTexts,
    };
  },

  computed: {
    ...mapState('counselorGrid', [
      'accreditationOptions',
      'isLoadingCompetenceAreas',
    ]),

    showFilter() {
      return (
        this.isLoadingCompetenceAreas || this.accreditationOptions.length > 0
      );
    },

    accreditations: {
      get() {
        return this.$store.state.counselorGrid.filteredAccreditations;
      },
      set(value) {
        this.$store.commit('counselorGrid/setFilteredAccreditations', value);
      },
    },
  },
};
</script>
